import React from 'react'
import Survey from './survey'
import Header from '../standartComponents/header'

const SurveyMain = (authUser) => {
  return (
    <>
    <Header authUser={authUser} />
    <Survey authUser={authUser} />
    </>
  )
}

export default SurveyMain